import { Widget } from "@typeform/embed-react";
import { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "../../components/ui/Button";
import ContentHeader from "../../components/app/headers/ContentHeader";
import {
  canGoBackInApp,
  goBackInApp,
} from "../../domains/app/utils/backNavigation";
import { useTranslation } from "react-i18next";

export default function RoomQuizSlidesPage({
  roomId: _roomId,
  quizId,
}: {
  roomId: string;
  quizId: string;
}) {
  const history = useHistory();
  const { t } = useTranslation();
  const [isFinished, setFinished] = useState(false);
  const footerCacheRef = useRef<HTMLDivElement>(null);

  // A quiz opened from a link has no page of ours behind it.
  const isInitialQuizPage = !canGoBackInApp();

  function handleQuizEndNavigation() {
    goBackInApp(history, "/discovery");
  }

  return (
    <div className="relative box-border overflow-hidden h-dvh flex flex-col items-center justify-center [&_.widget-container]:relative [&_.widget-container]:top-0 [&_.widget-container]:z-0 [&_.widget-container]:box-border [&_.widget-container]:w-full">
      {isFinished ? (
        <div className="p-[40px] flex flex-col items-center justify-center gap-6 [&_.heading]:font-dm-sans [&_.heading]:text-2xl [&_.heading]:font-bold [&_.heading]:leading-[28.8px] [&_.heading]:text-center [&_.text]:font-dm-sans [&_.text]:text-base/6 [&_.text]:font-normal  [&_.text]:text-center">
          <span className="heading">
            {t("Thank you for taking this quiz \uD83C\uDF4B!")}
          </span>
          <span className="text">
            {t(
              "Testing your knowledge keeps you at the cutting edge of medical advancements."
            )}
          </span>
          <Button
            variant="primary"
            size="lg"
            className="w-full"
            onClick={handleQuizEndNavigation}
          >
            {isInitialQuizPage ? t("Close") : t("Back")}
          </Button>
        </div>
      ) : (
        <>
          <div
            className="absolute inset-x-0 z-10010"
            style={{ top: "var(--safe-area-top)" }}
          >
            <ContentHeader transparent onBack={handleQuizEndNavigation} />
          </div>

          <Widget
            id={quizId}
            className="widget-container"
            // opacity={0}
            fullScreen
            onReady={() => {
              const footerCache = footerCacheRef.current;
              if (footerCache) footerCache.style.display = "none";
              setFinished(false);
            }}
            onStarted={() => {
              const footerCache = footerCacheRef.current;
              if (footerCache) footerCache.style.display = "block";
            }}
            onSubmit={() => {
              setFinished(true);
            }}
          />
        </>
      )}
    </div>
  );
}
